import { useEffect, useRef, useState } from 'react';

export default initialValue => {
    const [state, updateState] = useState(initialValue);
    const stateRef = useRef(state);
    useEffect(() => {
        stateRef.current = state;
    }, [state]);
    return [state, updateState, stateRef];
};
